module.exports = __webpack_public_path__ + "img/harnos_right.ecacc547.jpg";